var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.180392 0 0 0 0 0.356863 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__b",
    d: "M11.529 3.529c.26-.26.682-.26.942 0 .26.26.26.682 0 .942l-3.528 3.53 3.528 3.528c.235.234.258.6.07.86l-.07.082c-.26.26-.682.26-.942 0L8 8.943l-3.529 3.528c-.234.235-.6.258-.86.07l-.082-.07c-.26-.26-.26-.682 0-.942L7.057 8 3.53 4.471c-.235-.234-.258-.6-.07-.86l.07-.082c.26-.26.682-.26.942 0l3.53 3.528z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#prefix__a)",
    transform: "translate(-313)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(313)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#prefix__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.076f6a4173c277ec7f689f3b1eb10940.svg";
export { ForwardRef as ReactComponent };